import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class UsuarioService extends BaseService {
  constructor() {
    super(`${ConfigApi.usuarioURL}`);
  }

  async requestRegisterChatId() {
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/requestRegisterChatId`, {});
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  async registerChatIdByToken(token) {
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/registerChatIdByToken/${token}`, {});
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.login = '';
    this.idColaborador = undefined;
    this.idUsuarioPerfil = null;
    this.limit = 11;
    this.page = 0;
  }
}
export default new UsuarioService();
